export default __webpack_public_path__ + "static/media/giftVoucher@2x.f36bbfa2.png";